var $ = require('jquery');
require('fg-frontend/third/jquery.cookie');

var PLUGIN_NAME = 'globalFilter';

var DEFAULTS = {
  // cookieName:                'EDEE_SHOP_PERSISTENT_FILTER',
  afterSaveActionDefaultUrl: '/pl/produkty-detaliczne',
  saveActionUrl: '/pl/produkty-detaliczne',

  filterAppliedId: "filterApplied",
  parameterFilterId: "parameterFilter",

  bottomFilterId: "filterForm"
};

// The actual plugin constructor
function GlobalFilter(element, options) {
  this.element = element;

  this.options = $.extend(true, {}, DEFAULTS, options);
  this.$me = $(this.element);

  this.data = {};

  this.initialise();
}

/**
 * init
 */
GlobalFilter.prototype.initialise = function () {
  var self = this;

  self.data.$inputs = self.$me.find('input');
  self.data.$bottomFilterInputs = $(`#${self.options.bottomFilterId} input[id^=${self.options.parameterFilterId}]`)

  self.updateValuesFromDataAttr();
  self.bindEvents();
};

/**
 * bind events
 */
GlobalFilter.prototype.bindEvents = function () {
  var self = this;
  self.data.$inputs.on('change', function () {
    setTimeout(function () {
      self.updateComponentState();
      self.saveForm();
    }, 2000);
  });

  // UPDATE je řešený přes parcial update => viz configurePartialUpdate.js

  $('.js_category-alert').each(function () {
    self.handleAlertBox();
  });
};

/**
 * compute query parameters
 * @desc computes and returns query parameters
 */
GlobalFilter.prototype.computeParams = function (paramsArray, names) {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  urlParams.set(`frm.${this.options.filterAppliedId}`, "true")

  for (let name of names) {
    urlParams.delete(name)
  }

  for (let param of paramsArray) {
    urlParams.append(param.name, param.value)
  }

  return urlParams.toString()
}

/**
 * save form
 */
GlobalFilter.prototype.saveForm = function () {
  var self = this,
      $this,
      name,
      names = new Set(),
      paramsArray = [];

  self.$me.find('input').each(function () {
    $this = $(this);

    name = $this.attr('name').split(':')[ 1 ];
    names.add(`frm.${self.options.parameterFilterId}:${name}`)

    if ( $this.is(':checked') ) {
      paramsArray.push({ name:`frm.${self.options.parameterFilterId}:${name}`, value:$this.val() });
    }
  });

  $.ajax({
    url: `${self.options.saveActionUrl}?${self.computeParams(paramsArray, names)}`,
    type: "GET",
    xhrFields: {
      withCredentials: true
    },
    success: () => self.handleAfterSavingAction()
  })
};

/**
 * handle after saving action
 * @desc reloads or redirects
 */
GlobalFilter.prototype.handleAfterSavingAction = function () {
  var self = this;

  if ( $('.category-filter-and-sort').length === 0 ) {
    window.location.assign(self.options.afterSaveActionDefaultUrl);
  } else {
    window.location.replace(window.location.pathname)
  }
};

/**
 * update values from data-cookie attribute
 */
GlobalFilter.prototype.updateValuesFromDataAttr = function () {
  this.updateValues(this.element.dataset.cookie)
};

/**
 * update values from given string
 * @param {String} string input string (e.g. from cookie or data-cookie attribute)
 */
GlobalFilter.prototype.updateValues = function (string) {
  var self        = this,
      valuesArray = [],
      values,
      value,
      $globalFilterInput,
      $categoryFilterInput;

  self.data.specialniVyzivaCookiesState = 0;
  self.data.specialniVyzivaPageState = 0;
  self.data.alergenyCookiesState = 0;
  self.data.alergenyPageState = 0;

  if (string) {
    string = string.replace(/\"/g, '').replace(/\]\[/g, '|').replace(/\[/g, '').replace(/\]/g, '');
    valuesArray = string.split('|');

    self.data.$inputs.prop("checked", false);

    for ( var i in valuesArray ) {
      values = valuesArray[ i ].split(':@:');
      value = values.length == 2 ? values[ 1 ] : values[ 0 ];

      if ( value != '""' ) {
        $globalFilterInput = self.data.$inputs.filter('[value="' + value + '"]');
        $categoryFilterInput = $('.category-filter-container').find('input[value="' + value + '"]');
        $globalFilterInput.prop('checked', true);

        if ( $globalFilterInput.parents('.global-filter-group-specialni-vyziva').length == 1 ) {
          self.data.specialniVyzivaCookiesState++;

          if ( $categoryFilterInput.length != 0 ) {
            self.data.specialniVyzivaPageState++;
          }
        } else {
          self.data.alergenyCookiesState++;

          if ( $categoryFilterInput.length != 0 ) {
            self.data.alergenyPageState++;
          }
        }
      }
    }
  }
  self.updateComponentState();
};

/**
 * update component state
 */
GlobalFilter.prototype.updateComponentState = function () {
  var self    = this,
      $target = $('.global-filter-group');

  $target.each(function () {
    if ( $(this).find('input').filter(':checked').length == 0 ) {
      $(this).removeClass('active');
    } else {
      $(this).addClass('active');
    }
  });
  self.handleAlertBox();
};

/**
 * handle alert box
 */
GlobalFilter.prototype.handleAlertBox = function () {
  var self    = this,
      $target = $('.js_category-alert');

  if ( (self.data.specialniVyzivaCookiesState > 0) && (self.data.specialniVyzivaPageState == 0) && (self.data.alergenyPageState == 0) ) {
    $target.addClass('alert alert-products-empty').removeClass('hidden');
  } else {
    $target.addClass('hidden').removeClass('alert alert-products-empty');
  }
};

/**
 * decide, which methods will be "public"
 */
var API = {
  //action: GlobalFilter.prototype.action
};

/**
 * plugin go live
 * @param value - first param - decides, which action shall be executed
 *         if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
 *         if string && in API object - run method named as this value with all args[index > 0]
 * @return {*}
 */
$.fn[ PLUGIN_NAME ] = function (value) {
  var args = arguments;

  return this.each(function () {
    var $this = $(this);

    // get plugin instance
    var plugin = $this.data('plugin_' + PLUGIN_NAME);

    // if there's not, create one
    if ( !plugin ) {
      plugin = new GlobalFilter(this, value);
      $this.data('plugin_' + PLUGIN_NAME, plugin);
    }
    // if there is and first parameter is in predefined API methods, call it with rest of params
    else if ( API[ value ] ) {
      plugin[ value ].apply(plugin, Array.prototype.slice.call(args, 1));
    }
  });
};



// WEBPACK FOOTER //
// ./fe/web-b2b/src/js/eshop-widgets/jquery.global-filter.js